import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WebIcon(props: IconProps) {
    return <Icon {...props} iconKey={"web"}/>
}
